export default __webpack_public_path__ + "static/media/Plastic-Bags.70c29d82.png";